import { forEach } from 'lodash'

import { batchOpacityRevealAnimation } from './shared'
import { Animation } from '@/types'

export const accordionTabRevealAnimation = ({ context, reverse }: Animation) => {
  const tabs = context.selector?.('[data-motion-accordion-tab]')

  let tabsBatchAnimation: ScrollTrigger[]
  if (tabs.length > 0) {
    tabsBatchAnimation = batchOpacityRevealAnimation({
      targets: tabs,
      reverse,
      stagger: {
        amount: 0.12
      }
    })
  }

  return () => {
    forEach(tabsBatchAnimation || [], (animation) => animation.kill())
  }
}
